<template>
  <div class="MissionManagement">
    <request-management-search-panel
      :accessTo="accessTo"
      @search="setSearchParams"
    />

    <box class="mt-2" :title="$t('missionList')">
      <div class="missionList">
        <div v-if="list.length > 0">
          <mission-management-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClickMission"
          />
          <mission-management-list-mob
            @onClick="onClickMission"
            :list="list"
            class="hidden-md-and-up"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="d-flex px-4 py-2">
              <v-btn outlined class="thisBtn" color="primary" small @click="approveSelected">{{
                $t("approveSelected")
              }}</v-btn>
              <v-btn
                outlined
                color="primary"
                class="mx-2 thisBtn"
                small
                @click="rejectSelected"
                >{{ $t("rejectSelected") }}</v-btn
              >
            </div>
          </v-card-actions>
        </div>
        <div v-else>
          <EmptyList :state="stateList">
            <!-- <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom
              color="deep-purple accent-4"></v-progress-linear> -->
          </EmptyList>
        </div>
      </div>
    </box>
    <mission-management-details
      class="mt-2"
      ref="MissionManagementDetails"
      @refresh="search"
      @operationOnRequest="operationOnRequestDetails"
    />
  </div>
</template>

<script>
import RequestManagementSearchPanel from "../../components/requestManagement/RequestManagementSearchPanel.vue";
import RequestState from "@/model/RequestState";
import ResultType from "../../model/ResultType";
import AccessToType from "../../model/AccessToType";
import MissionManagementListWeb from "../../components/requestManagement/mission/MissionManagementListWeb.vue";
import MissionManagementListMob from "../../components/requestManagement/mission/MissionManagementListMob.vue";
import MissionManagementDetails from "../../components/requestManagement/mission/MissionManagementDetails.vue";
import TextUtils from "../../utils/TextUtils";
import EosToastType from "../../model/EosToastType";
import StateList from "../../model/StateList";
import EosUtils from "../../utils/EosUtils";
import PushNotificationHelper from "../../notification/PushNotificationHelper";

export default {
  components: {
    RequestManagementSearchPanel,
    MissionManagementListWeb,
    MissionManagementListMob,
    MissionManagementDetails,
  },
  data() {
    return {
      accessTo: -1,
      list: [],
      searchParams: {},
      stateList: null,
      loading: false,
    };
  },
  watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 30000)
      },
    },
  created() {
    this.accessTo = AccessToType.Mission;
    //console.log(this.accessTo);
  },
  methods: {
    setSearchParams(params) {
      this.searchParams = params;
      this.search();
    },
    search() {
      ////console.log(params);
      debugger
      var params = this.searchParams;
      this.list = [];
      this.stateList = StateList.loading();

      this.$store
        .dispatch("GetMissionListForAdmins", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.list = result.data;
            this.stateList = null;
          } else {
            this.stateList = StateList.error(result.error);
          }
        });
    },
    onClickMission(item) {
      //console.log(item);
      this.hideDetails();
      this.$refs.MissionManagementDetails.show(item);
    },
    hideDetails() {
      this.$refs.MissionManagementDetails.hide();
    },

    async approveSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Approve;
      this.OprationOnRequest(requestState, selectedList);
    },
    rejectSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Reject;
      this.OprationOnRequest(requestState, selectedList);
    },
    operationOnRequestDetails(requestState, selectedList) {
      this.OprationOnRequest(requestState, selectedList);
    },
    async OprationOnRequest(requestState, selectedList) {
      //console.log(selectedList);
      var params = [];
      var adminPerno = this.$store.state.auth.auth.username;

      if (EosUtils.isWebKartAdmin()) {
        //
        selectedList.forEach((item) => {
          var param = {
            PageNo: TextUtils.convertToEnglishDigits(
              item.Pageno.toString().trim()
            ),
            Year: item.Year,
            adminPerno: adminPerno,
            perno: TextUtils.convertToEnglishDigits(
              item.Perno.toString().trim()
            ),
            RequestState: requestState,
            ReasonOfAdmin: "",
            Status: 10,
          };
          params.push(param);
        });
        this.OprationOnMissionRequest(params);
      } else {
        //
        let callback = function (resList) {
          debugger
          //console.log(resList);
          resList.forEach((res, index) => {
            if (res.type === ResultType.success) {
              var s = res.data;
              //console.log(s, index);
              var item = selectedList[index];
              var param = {
                PageNo: TextUtils.convertToEnglishDigits(
                  item.Pageno.toString().trim()
                ),
                Year: item.Year,
                adminPerno: adminPerno,
                perno: TextUtils.convertToEnglishDigits(
                  item.Perno.toString().trim()
                ),
                RequestState: requestState,
                ReasonOfAdmin: "",
                Status: s,
              };
              params.push(param);
              debugger;
            }
          });
        };
        if (selectedList.length > 0) {
          debugger
          await this.GetApproveDegree(selectedList, callback).then(() => {
            debugger
            this.OprationOnMissionRequest(params);
          });
        }
      }
    },
    async GetApproveDegree(list, callback) {
      let promises = [];
      list.forEach((item) => {
        //console.log(item);
        var approveParams = {
          perno: TextUtils.convertToEnglishDigits(item.Perno.toString().trim()),
          section: TextUtils.convertToEnglishDigits(
            item.Section.toString().trim()
          ),
          status: TextUtils.convertToEnglishDigits(
            item.Status.toString().trim()
          ),
          pageType: TextUtils.convertToEnglishDigits(
            item.Type.toString().trim()
          ),
        };
debugger
        promises.push(
          this.$store.dispatch("GetMissionApproveDegree", { approveParams })
        );
      });

      await Promise.all(promises)
        .then(callback)
        .catch((err) => {
          console.log(err);
        });
    },
    OprationOnMissionRequest(params) {
      //console.log(params);
      debugger
      this.$store
        .dispatch("OprationOnMissionRequest", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.search();
            if (result.data && result.data.length > 0) {
              var description = result.data[0].Description;
              this.$EosToast.show({
                type: EosToastType.success,
                msg: description,
              });
              //this.$refs.snackbar.show("success", description);
              params.forEach((param) => {
                PushNotificationHelper.sendNotification(
                  param.adminPerno,
                  param.perno,
                  param.RequestState,
                  param.RequestState
                );
              });
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error,
            });
            //this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style>
.thisBtn{
  background:white;
}
</style>
